// Конфигурация API
// Используем относительный путь для локальной разработки
// В продакшене можно использовать переменные окружения через vue.config.js

const API_CONFIG = {
  // Базовый URL бекенда
  // Используем относительный путь для работы с тем же доменом
  // Для продакшена можно установить через process.env.VUE_APP_API_URL
  baseURL: process.env.VUE_APP_API_URL || 'http://5.149.248.245:3000/api'
}

export default API_CONFIG

